import React, { cloneElement, useEffect } from 'react';
import { useLocation } from 'react-router';

import { ChatInput, ChatInputProps } from '~/components/chat';
import { useTouchDevice } from '~/hooks/MediaQueryHook';
import { mobileAlfredPaths } from '~/Root';
import { AppRoute } from '~/routes';
import { appPaths } from '~/routes/app-paths';
import { useFlags } from '~/stores/use-flags/useFlags';
import { useSubscription } from '~/stores/use-subscription/useSubscription';
import { useReasonerParams } from '~/views/alfred/research/hooks/useReasonerParams';
import { useChatNavigation } from '~/views/alfred/use-chat-navigation/useChatNavigation';
import { MarketInsightDrawerRender } from '~/views/dashboard/whats-new-widget/components/market-insight-drawer/MarketInsightDrawerRender';
import { EarningsInsightDrawer } from '~/views/earnings-insight-drawer/EarningsInsightDrawer';
import { InsightsFullDrawerRender } from '~/views/insights/components/insights-drawer/InsightsFullDrawerRender';
import { Widgets } from '~/views/widgets/Widgets';
import { InsightsDrawerRender } from '~/widgets/insight-widget/components/insight-drawer/InsightsDrawerRender';

import * as S from './View.styles';

export interface AccountViewProps {
  config: AppRoute;
  showHeader: boolean;
}

export const View = ({ config }: AccountViewProps) => {
  const location = useLocation();
  const isTouchDevice = useTouchDevice();
  const isEarningsInsightsEnabled = useFlags(state =>
    state.getFeatureFlagState('earnings_insights')
  );

  const { navigateToConversation } = useChatNavigation();
  const { conversationId } = useReasonerParams();
  const isAlfredPath = location.pathname === appPaths.alfred;

  const isBasicUser = useSubscription(state => state.isBasicUser());
  const { element } = config;

  const content = cloneElement(element, {
    renderChatInput: (props?: ChatInputProps) =>
      isBasicUser ? null : <ChatInput {...props} />,
  });

  const isMobileAlfredPath =
    mobileAlfredPaths.includes(location.pathname) && isTouchDevice;

  useEffect(() => {
    if (isTouchDevice && !isAlfredPath) {
      navigateToConversation(conversationId);
    }
  }, [conversationId, isAlfredPath, isTouchDevice, navigateToConversation]);

  return (
    <>
      {/* {showHeader && !isMobileAlfredPath && <AppHeader />} */}
      <S.ViewRoot id={'root-view'}>
        {!isMobileAlfredPath && (
          <>
            <Widgets />
            <InsightsDrawerRender />
            <InsightsFullDrawerRender />
            <MarketInsightDrawerRender />
            {isEarningsInsightsEnabled && <EarningsInsightDrawer />}
          </>
        )}
        {content}
      </S.ViewRoot>
    </>
  );
};
